module.exports = __webpack_public_path__ + "static/media/body-female.af0a1fff.svg";